import { Action } from '@ngrx/store';
import { TaskInterface } from 'app/task/models/task.model';

import { TaskActionType } from './task-action-type.enum';


export class CloseTask implements Action {
  public readonly type: TaskActionType = TaskActionType.CloseTask;

  constructor(public readonly payload: TaskInterface) { }
}

export class CloseTaskCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.CloseTaskCompleted;

  constructor(public readonly payload: TaskInterface) { }
}

export class CloseTaskFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.CloseTaskFailed;

  constructor(public readonly payload: string) { }
}
